module.exports = __webpack_public_path__ + "img/red-circle.3a5479c0.svg";